let maps = {};
let infoWindow;

let gapi_script = document.createElement('script');
gapi_script.src = 'https://maps.googleapis.com/maps/api/js?key=' + google_api_key + '&callback=initMaps';
document.head.appendChild(gapi_script);

$(document).on('click', '.information-block-header', e => {
	$(e.currentTarget).parent().toggleClass('open');
});

let markers = {};

const initMaps = () => {
	$('.information-block-map').each((i, e) => {
		let el = $(e);
		maps[el.attr('id')] = new google.maps.Map(document.getElementById(el.attr('id')), {
			center: {lat: 49.0484601, lng: 14.4418441},
			zoom: 14,
		});

		var points = JSON.parse(el.attr('data-markers'));
		var map_markers = [],
			im,
			marker;

		for (im = 0; im < points.length; im++) {
			marker = new google.maps.Marker({
				position: new google.maps.LatLng(parseFloat(points[im].lat),parseFloat(points[im].lng)),
				id: points[im].id,
				icon: '/assets/svg/icon_map_pin.svg',
				info: points[im].title,
				map: maps[el.attr('id')]
			});

			google.maps.event.addListener(marker, 'click', function () {
				if (infoWindow)
					infoWindow.close();

				infoWindow = new google.maps.InfoWindow();
				$('#block-' + el.attr('data-category')).find('.information-block-item').removeClass('open');
				$('#information-block-item-' + this.id).addClass('open');
				infoWindow.setContent(this.info);
				infoWindow.open(maps[el.attr('id')], this);
			});

			map_markers.push(marker);

		}
		markers[el.attr('data-category')] = map_markers;

		if (map_markers.length === 1)
		{
			maps[el.attr('id')].setCenter(map_markers[0].getPosition());
			maps[el.attr('id')].setZoom(14);
		}else {
			var ib, bounds = new google.maps.LatLngBounds();
			for (ib = 0; ib < markers[el.attr('data-category')].length; ib++) {
				bounds.extend(markers[el.attr('data-category')][ib].getPosition());
			}
			maps[el.attr('id')].fitBounds(bounds);
		}


	});
};

$(document).on('click', '.block-item-header', e => {
	let el = $(e.currentTarget);
	let mapId = el.attr('data-map');
	let map = maps[mapId];
	let parent = el.parent();
	let mapMarkers = markers[el.attr('data-category')];

	if (infoWindow)
		infoWindow.close();

	infoWindow = new google.maps.InfoWindow();

	if (parent.hasClass('open')) {
		parent.removeClass('open');

		if (mapMarkers.length === 1)
		{
			map.setCenter(mapMarkers[0].getPosition());
			map.setZoom(14);
		}else {
			var ib, bounds = new google.maps.LatLngBounds();
			for (ib = 0; ib < mapMarkers.length; ib++) {
				bounds.extend(mapMarkers[ib].getPosition());
			}
			map.fitBounds(bounds);
		}

	} else {
		parent.parent().find('.information-block-item').removeClass('open');
		parent.addClass('open');

		for (let ic in mapMarkers)
		{
			if (mapMarkers.hasOwnProperty(ic))
			{
				if (mapMarkers[ic].id === parseInt(el.attr('data-item-id'))) {
					let gps = el.attr('data-gps').split(',');
					let gpsPoint = {lat: parseFloat(gps[0]), lng: parseFloat(gps[1])};
					infoWindow.setContent(mapMarkers[ic].info);
					infoWindow.open(map, mapMarkers[ic]);
					maps[mapId].setCenter(gpsPoint);
					maps[mapId].setZoom(14);
				}
			}
		}
	}
});